import { Progress as ThemeUIProgress } from '@apia/theme';
import useContext from '../../../hooks/useContext';
import UploaderContext from './context';

const Progress = () => {
  const { progress } = useContext(UploaderContext);

  return <ThemeUIProgress max={100} value={Math.round(progress)} />;
};

export default Progress;
